import { Controller } from "@hotwired/stimulus";
import * as Bootstrap from 'bootstrap';

export default class extends Controller {
  connect() {
    this.reveal();
  }

  reveal() {
    if (this.element && this.element.classList.contains("collapse")) {
      const bsCollapse = new Bootstrap.Collapse(this.element, { toggle: false });
      bsCollapse.show()
    }
  }
}
